module.exports = __WEBPACK_EXTERNAL_MODULE_9__;


//////////////////
// WEBPACK FOOTER
// external "rxjs/add/operator/map"
// module id = 9
// module chunks = 0